import { render, staticRenderFns } from "./articleListByTag.vue?vue&type=template&id=5bd3d134&scoped=true&"
import script from "./articleListByTag.vue?vue&type=script&lang=js&"
export * from "./articleListByTag.vue?vue&type=script&lang=js&"
import style0 from "./articleListByTag.vue?vue&type=style&index=0&id=5bd3d134&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd3d134",
  null
  
)

export default component.exports